<template>
    <svg class="stat-circle" width="50" viewBox="0 0 20 20" :style="cssProps">
        <circle class="bg" cx="10" cy="10" r="8"></circle>
        <circle class="inner-progress" cx="10" cy="10" r="8" :data-percentage="percentage"></circle>
        <text x="50%" y="55%">{{ percentage }}%</text>
    </svg>
</template>

<script>
export default {
  name: 'CircleProgress',
  props: ['percentage'],
  computed: {
    cssProps () {
      return {
        '--dashoffset': (-51 + ((51 / 100) * this.percentage))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.stat-circle {
    circle.bg {
        ::v-deep{
            fill: none;
            stroke: transparent;
            stroke-width: 2;
        }
    }
    circle.inner-progress {
        ::v-deep{
            fill: none;
            stroke: $color2;
            stroke-width: 2;
            stroke-dasharray: 51 51;
            stroke-dashoffset: var(--dashoffset);
            stroke-linecap: round;
        }
    }
    text {
        ::v-deep{
            font-size: 4px;
            text-anchor: middle;
        }
    }
}

</style>
